export default function FooterSection() {
  return (
    <>
      <footer className="layout-dark bg-baby-pink-footer baby-pink-wave-footer">
        <div className="container padding-top-70px sm-ptb-20px border-extra-light-white border-bottom-1">
          <div className="row">
            <div className="col-lg-2 col-md-3">
              <div className="nile-widget widget_nav_menu sm-mb-45px">
                <h2 className="title border-extra-light-white border-bottom-1 padding-bottom-15px margin-bottom-15px">
                  Featured Links
                </h2>
                <ul className="footer-menu">
                  <li className="scroll ">
                    <a href="#home">Home</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-10">
              <div className="nile-widget">
                <div className="margin-bottom-60px sm-mb-10px">
                  <h2
                    className="title border-extra-light-white border-bottom-1 padding-bottom-15px "
                    style={{ color: '#1c1a16' }}
                  >
                    Location
                  </h2>
                  <div className="contact-info opacity-9 telaction">
                    <div className="row">
                      <div className="col-md-3 col-sm-6">
                        <div className="text padding-tb-5px">
                          <div className="nile-widget widget_nav_menu sm-mb-45px">
                            <ul className="footer-menu">
                              <li className="scroll ">
                                <a href="#about">About Us</a>
                              </li>
                            </ul>
                          </div>
                          <br />
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-6">
                        <div className="text padding-tb-5px">
                          <div className="nile-widget widget_nav_menu sm-mb-45px">
                            <ul className="footer-menu">
                              <li className="scroll ">
                                <a href="#courese">Courses</a>
                              </li>
                            </ul>
                          </div>
                          <br />
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-6">
                        <div className="text padding-tb-5px">
                          <div className="nile-widget widget_nav_menu sm-mb-45px">
                            <ul className="footer-menu">
                              <li className="scroll ">
                                <a href="#Batch">Batch</a>
                              </li>
                            </ul>
                          </div>
                          <br />
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-6">
                        <div className="text padding-tb-5px">
                          <div className="nile-widget widget_nav_menu sm-mb-45px">
                            <ul className="footer-menu">
                              <li className="scroll ">
                                <a href="#testimonial">Testimonial</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr style={{ borderTop: '1px solid #f0f0f0' }} />
            <div className="col-lg-12">
              <div className="nile-widget widget_nav_menu sm-mb-45px">
                <h2 className="title border-extra-light-white border-top-1 padding-top-15px ">
                  Location
                </h2>

                <ul className="footer-menu">
                  <p style={{ color: 'white' }}>
                    Neithal Nagar, New Housing Unit,Opp Serfoji College,Elisa Nagar, Thanjavur,
                    Tamil Nadu 613005
                  </p>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="copy-right bg-baby-pink-footer padding-bottom-10px">
          <div className="container padding-tb-20px">
            <div className="row">
              <div className="col-lg-8">
                <div className="copy-right-text text-lg-left text-center sm-mb-15px ">
                  Navira Live © 2020
                </div>
              </div>
              <div className="col-lg-4">
                <ul className="social-media social_media_footer list-inline text-lg-right text-center margin-0px">
                  <li className="list-inline-item">
                    <a className="facebook" href="#fb" target="_blank">
                      <i className="fa fa-facebook" aria-hidden="true" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="linkedin" href="#linkedIn" target="_blank">
                      <i className="fa fa-linkedin" aria-hidden="true" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="twitter" href="#twitter" target="_blank">
                      <i className="fa fa-instagram" aria-hidden="true" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
